// extracted by mini-css-extract-plugin
export default {"wrapperPagination":"styles_wrapperPagination__9xvQM","counterPagination":"styles_counterPagination__snEIp"};